export const CONTAINER_TYPE_OPTIONS = [
  { value: 'domain', label: 'Domain', badge: 'D' },
  { value: 'topic', label: 'Topic', badge: 'T' },
  { value: 'subtopic', label: 'Subtopic', badge: 'ST' },
];

export const CONTAINER_TYPE_DETAILS = Object.fromEntries(
  CONTAINER_TYPE_OPTIONS.map((option) => [option.value, option]),
);
